<template>
  <div
    :class="placeClasses"
    @click="onClick"
    @mouseover.prevent="onMouseOver(false)"
    @mouseleave="onMouseOut"
  >
    <address class="locator__place-small-address">
      <h4 v-html="institutionData.institution.name"></h4>
      <p v-html="streetWithNumber"></p>
      <p v-html="postalWithCity"></p>
    </address>
    <div class="locator__place-promo-icons">
      <template v-for="promotion in badgePromotionsFirst(promotions)">
        <place-promotion
          :promotion="promotion"
          :institutionData="institutionData"
          :dropdown-id="institutionData.id"
          :disable-dropdown-item-class="true"
        ></place-promotion>
      </template>
    </div>

    <div
      class="dropdown dropdown-main-list is-right is-hoverable"
      :class="badgePromotionsDropdown(promotions).length ? '' : 'hidden'"
    >
      <div
        @mouseover="isActive = true"
        @mouseleave="isActive = false"
        class="dropdown-trigger"
        :aria-controls="'dropdown-menu'+institutionData.id"
        v-if="badgePromotionsDropdown(promotions).length"
      >
        <span class="dropdown-text">akcje specjalne</span>
        <span v-if="!isActive">
          <i class="arrow black down"></i>
        </span>
        <span v-if="isActive">
          <i class="arrow black down"></i>
        </span>
      </div>
      <div
        class="dropdown-menu"
        :id="'dropdown-menu'+institutionData.id"
        role="menu"
      >
        <div class="dropdown-content top-bar-color">
          <div class="dropdown-item">
            <div class="locator__place-promo-icons">
              <template v-for="promotion in badgePromotionsDropdown(promotions)">
                <place-promotion
                  :promotion="promotion"
                  :institutionData="institutionData"
                  :dropdown-id="institutionData.id"
                ></place-promotion>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlacePromotion from "./placePromotion";
import cloneDeep from "lodash/cloneDeep";

export default {
  name: "place",
  props: ["map", "institutionData", "placeListVisible", "marker"],
  components: {
    PlacePromotion
  },
  data() {
    return {
      showPopup: false,
      popupTop: 0,
      popupLeft: 0,
      placeClasses: {
        locator__place: true,
        hover: false,
        visible: true,
        "extended-info": false
      },
      icon: "",
      // markerVisibility: true,
      googleMarker: null,
      isActive: ""
    };
  },
  watch: {
    icon(icon) {
      if (!this.googleMarker) return;
      this.googleMarker.setIcon(icon);
    },
    "$store.state.selectedPromotions"(selectedPromotion) {
      if (!this.googleMarker) return false;
      this.googleMarker.setVisible(!this.institutionData.markerHidden);
      // this.markerVisibility = !this.institutionData.markerHidden;
    },
    "$store.state.selectedInstitution"(institutionData) {
      if (this.isSelectedInstitution()) {
        this.showMarker();
        this.setActiveIcon();
      } else {
        this.setNormalIcon();

        if (institutionData) {
          this.hideMarker();
        } else if (this.markerShouldBeVisible()) {
          this.showMarker();
        }
      }
    },
    placeListVisible(newVal) {
      this.placeClasses["visible"] = newVal;
    }
  },
  computed: {
    activeIcon() {
      if (
        this.$siteVariantImages[this.$siteVariant] &&
        this.$siteVariantImages[this.$siteVariant]["pinActive"]
      ) {
        return this.$siteVariantImages[this.$siteVariant]["pinActive"];
      }
      return require("../" + this.$siteAssetDir + "/pinActive.svg");
    },
    normalIcon() {
      if (
        this.$siteVariantImages[this.$siteVariant] &&
        this.$siteVariantImages[this.$siteVariant]["pinNormal"]
      ) {
        return this.$siteVariantImages[this.$siteVariant]["pinNormal"];
      }
      return require("../" + this.$siteAssetDir + "/pinNormal.svg");
    },
    streetWithNumber() {
      if (!this.institutionDataHasInstitution()) return "";
      let street = this.institutionData.institution.street_name;
      let buildingNumber = this.institutionData.institution.building_number;
      let apartmentNumber = this.institutionData.institution.apartment_number;

      if (!street) return "";
      let streetWithNumber = street + (" " + buildingNumber) || "";
      if (apartmentNumber)
        streetWithNumber = streetWithNumber + "/" + apartmentNumber;

      return streetWithNumber;
    },
    postalWithCity() {
      if (!this.institutionDataHasInstitution()) return "";
      let postalCode = this.institutionData.institution.postal_code;
      if (!postalCode) postalCode = "";
      if (
        postalCode.length > 2 &&
        postalCode.indexOf("-") < 0 &&
        this.$appLang !== "LT"
      ) {
        postalCode = postalCode.substr(0, 2) + "-" + postalCode.substr(2);
      }
      return postalCode + " " + this.institutionData.institution.city;
    },
    promotions() {
      if (!this.institutionDataHasPromotion()) return "";
      if (!this.institutionData && !this.institutionData.promotions) return [];
      let promotionsCopy = cloneDeep(this.institutionData.promotions);
      // let promotionsCopy = this.institutionData.promotion.concat();
      promotionsCopy.sort((a, b) => {
        if (a.order_priority === b.order_priority) return 0;
        return a.order_priority < b.order_priority ? -1 : 1;
      });

      // Specjalny kod dla CNW
      if (this.$siteVariant == 2) {
        // Jeżeli jest promocja z id 7 (Kupon JZO dla variluxa) a nie ma
        // Kuponu variulxa to pokazujemy ikonkę na liście kuponu JZO
        let hasVariluxPromo =
          promotionsCopy.findIndex(item => item.id === 6) + 1;

        if (!hasVariluxPromo) {
          let hasJzoPromo = promotionsCopy.findIndex(item => item.id === 7) + 1;

          if (hasJzoPromo)
            promotionsCopy[hasJzoPromo - 1].visible_on_places_list = true;
        }
      }
      return promotionsCopy;
    },
    institutionId() {
      if (!this.institutionDataHasInstitution()) return -1;
      let institution = this.institutionData.institution;
      return institution.id || -1;
    },
    markerPosition() {
      if (!this.institutionDataHasInstitution()) return null;
      let lat = this.institutionData.institution.lat;
      let lng = this.institutionData.institution.lng;

      if (!lat || !lng) {
        return null;
      }
      return { lat: parseFloat(lat), lng: parseFloat(lng) };
    }
  },
  methods: {
    badgePromotionsFirst(promo) {
      return promo.filter(
        el =>
          (!el.hasOwnProperty("visible_menu") ||
            (el.hasOwnProperty("visible_menu") && !el.visible_menu))
      );
    },
    badgePromotionsDropdown(promo) {
      return promo.filter(
        el =>
          el.hasOwnProperty("visible_menu") && el.visible_menu
      );
    },
    downloadPromotionAttachment(promotion, event) {
      if (!promotion.download_from_places_list) return;
      event.preventDefault();
      event.stopPropagation();
      let url = this.getPromotionAttachmentUrl(promotion);
      window.open(url);
    },
    institutionDataHasInstitution() {
      if (!this.institutionData) return false;
      if (!this.institutionData.institution) return false;
      return true;
    },
    institutionDataHasPromotion() {
      if (!this.institutionData) return false;
      if (!this.institutionData.promotions) return false;
      return true;
    },
    getPromotionAttachmentUrl(promotionData) {
      if (!promotionData.attachment_url) return "";
      let baseUrl = promotionData.attachment_url;
      baseUrl += "?institution=" + this.institutionData.institution.id;
      return baseUrl;
    },
    isSelectedInstitution() {
      let selectedInstitution = this.$store.state.selectedInstitution;
      return (
        selectedInstitution &&
        selectedInstitution.institution.id === this.institutionId
      );
    },
    scrollListToThisPlace() {
      this.$el.offsetParent.scrollTop = this.$el.offsetTop;
    },
    onMouseOver(withScroll = false) {
      this.setActiveIcon();
      this.placeClasses["hover"] = true;
      if (withScroll) this.scrollListToThisPlace();
      this.setMarkerAnimation("BOUNCE");
    },
    onMouseOut() {
      this.setNormalIcon();
      this.placeClasses["hover"] = false;
      this.removeMarkerAnimation();
    },
    setMarkerAnimation(animationName = "BOUNCE") {
      if (!this.googleMarker) return;
      this.googleMarker.setAnimation(google.maps.Animation[animationName]);
    },
    removeMarkerAnimation() {
      if (!this.googleMarker) return;
      this.googleMarker.setAnimation(null);
    },
    setActiveIcon() {
      this.icon = this.activeIcon;
    },
    setNormalIcon(force = false) {
      if (!this.isSelectedInstitution() || force) this.icon = this.normalIcon;
    },
    onClick() {
      parent.dataLayer.push({
        miasto: this.institutionData.institution.city,
        nazwasalonu: this.institutionData.institution.name,
        event: "pinezka-klik"
      });
      this.$store.commit("selectInstitution", this.institutionData.institution);
    },
    hideMarker() {
      if (!this.googleMarker) return;
      this.googleMarker.setVisible(false);
    },
    showMarker() {
      if (!this.googleMarker) return;
      this.googleMarker.setVisible(true);
    },
    markerShouldBeVisible() {
      return !this.institutionData.markerHidden;
    },
    createMarker() {
      if (!this.markerPosition) return;
      // console.log(this.markerPosition)
      this.googleMarker = new google.maps.Marker({
        position: this.markerPosition,
        icon: this.normalIcon,
        title: this.institutionData.institution.name || ""
      });

      this.googleMarker.addListener("mouseover", this.onMouseOver);
      this.googleMarker.addListener("mouseout", this.onMouseOut);
      this.googleMarker.addListener("click", this.onClick);
      this.$emit("markerCreated", this.googleMarker);
    },
    loadPromoInContainer(el) {
      let promo_container = document.getElementById("promo-container");
      let promoLogo = document.querySelectorAll(
        "[data-institution-promotion='" + el + "']"
      );
      console.log(promoLogo);
    },
    toggleVisibility() {
      this.isActive = !this.isActive;
    }
  },
  mounted() {
    this.$googleApiPromise.then(() => {
      this.createMarker();
    });

    // TODO: Trzeba to przerobić żeby nie było obserwowane przy każdej zmianie
    this.$store.subscribe((mutation, state) => {
      this.placeClasses["visible"] =
        !this.institutionData.hideOnList && !this.institutionData.markerHidden;
    });
  }
};
</script>

<style lang="scss" scoped>
.locator__place-info-window {
  transform: translateX(-50%);
  font-weight: bold;
  z-index: 1000000000;
  font-size: 120%;
  max-width: 300px;
  text-align: center;
  position: absolute;
}

.dropdown-title {
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 700;
  color: white;
}

.dropdown-trigger {

  display: flex;
  flex-direction: column;
  justify-self: center;
  text-align: center;

  .dropdown-text {
    max-width: 48px;
    font-size: 11px;
  }

  div {
    width: 35px;
    height: 5px;
    background-color: black;
    margin: 6px 0;
  }
}

.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
